import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/Collapse.svg'
import _imports_3 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 page-fill" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col flex-1 min-h-0 overflow-hidden"
}
const _hoisted_3 = {
  class: "row w-full justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "flex flex-row-reverse" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_8 = { class: "flex flex-row-reverse mr-2 relative" }
const _hoisted_9 = {
  key: 0,
  class: "card shadow-sm z-50 absolute cursor-pointer top-10"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_12 = { class: "flex flex-col h-full" }
const _hoisted_13 = { class: "flex-1 overflow-auto" }
const _hoisted_14 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_15 = { class: "formcontainer flex flex-col" }
const _hoisted_16 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_19 = {
  key: 0,
  class: "error-text"
}
const _hoisted_20 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_21 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_22 = { class: "w-6/12" }
const _hoisted_23 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_24 = {
  key: 0,
  class: "error-text"
}
const _hoisted_25 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_26 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_27 = { class: "w-3/6 leftspacing" }
const _hoisted_28 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_29 = {
  key: 0,
  class: "error-text"
}
const _hoisted_30 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_31 = { class: "w-6/12" }
const _hoisted_32 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_33 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_34 = { class: "w-3/6 leftspacing" }
const _hoisted_35 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_36 = { class: "w-6/12" }
const _hoisted_37 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_38 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_39 = { class: "w-3/6 leftspacing" }
const _hoisted_40 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_41 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_42 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_43 = { class: "w-full" }
const _hoisted_44 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_45 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_46 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_47 = { class: "w-full" }
const _hoisted_48 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_49 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_50 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_51 = { class: "w-full" }
const _hoisted_52 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_53 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_54 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_55 = { class: "w-full" }
const _hoisted_56 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_57 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_58 = { class: "w-full col-md-6 mt-3" }
const _hoisted_59 = { class: "w-full col-md-6 mt-3" }
const _hoisted_60 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_61 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_Select = _resolveComponent("Select")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.label), 1),
            _createElementVNode("input", {
              type: "file",
              accept: ".xls,.xlsx",
              class: "hidden",
              ref: "file",
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fileReader($event))),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetFileInput && _ctx.resetFileInput(...args)))
            }, null, 544),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: _normalizeClass(["flex", !_ctx.columnObject ? 'filterButton' : 'filterButtondisabled pointer-events-none']),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
              }, [
                (_ctx.columnObject)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                  : (_openBlock(), _createElementBlock("img", _hoisted_7)),
                _cache[33] || (_cache[33] = _createTextVNode(" Filters "))
              ], 2),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "btnprimary btns flex justify-center items-center",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleDropdown($event)))
                }, _cache[34] || (_cache[34] = [
                  _createTextVNode("Add "),
                  _createElementVNode("img", {
                    src: _imports_2,
                    alt: "",
                    class: "ml-2"
                  }, null, -1)
                ])),
                (_ctx.showBlock && _ctx.showDropdown)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                      _createElementVNode("li", {
                        class: "px-4 py-2 cursor-pointer border-b h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openFileModal && _ctx.openFileModal(...args)))
                      }, _cache[35] || (_cache[35] = [
                        _createElementVNode("div", null, "Import", -1)
                      ])),
                      _createElementVNode("li", {
                        class: "px-4 py-2 cursor-pointer border-b h-7 border-lightgrey hover:bg-lightgrey text-sm flex items-center",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addControls && _ctx.addControls(...args)))
                      }, _cache[36] || (_cache[36] = [
                        _createElementVNode("div", null, "Create", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _cache[54] || (_cache[54] = _createElementVNode("div", { class: "text-xs mt-3" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. ", -1)),
          _createVNode(_component_tableData, {
            class: "flex-1 min-h-0 mt-5 table-section",
            tableRowData: _ctx.tableRow,
            headersData: _ctx.headers,
            tableRouteArr: _ctx.optionsValue,
            loadData: _ctx.dataLoading
          }, null, 8, ["tableRowData", "headersData", "tableRouteArr", "loadData"]),
          (_ctx.toolTipActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showModal)
            ? (_openBlock(), _createBlock(_component_popup, {
                key: 1,
                class: "",
                popUp: _ctx.showModal
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[38] || (_cache[38] = _createElementVNode("h1", { class: "pl-2" }, "Internal Control", -1)),
                    _createElementVNode("button", {
                      class: "float-right text-3xl",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onCancelbtn('close')))
                    }, _cache[37] || (_cache[37] = [
                      _createElementVNode("img", {
                        src: _imports_3,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("fieldset", null, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _cache[39] || (_cache[39] = _createElementVNode("label", { class: "controllabel" }, "Title", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text",
                                  class: _normalizeClass(["inputboxstyling mt-2 mt-2", {
												'is-invalid': _ctx.v$.controlObject.controlTitle.$error
											}]),
                                  placeholder: "Title",
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.controlObject.controlTitle) = $event)),
                                  onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.controlObject.controlTitle.$touch()))
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.controlObject.controlTitle,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.controlObject.controlTitle.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                      (_ctx.v$.controlObject.controlTitle.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Required"))
                                        : (_ctx.v$.controlObject.controlTitle.required && _ctx.v$.controlObject.controlTitle.restrictCharacters100.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Charcter Limit is exceeded"))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _cache[41] || (_cache[41] = _createElementVNode("label", { class: "controllabel" }, "Number", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
												'is-invalid': _ctx.v$.controlObject.controlNumber.$error || _ctx.checkControlNumber
											}]),
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.controlObject.controlNumber) = $event)),
                                  placeholder: "Number",
                                  onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.controlObject.controlNumber.$touch()))
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.controlObject.controlNumber,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.controlObject.controlNumber.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      (_ctx.v$.controlObject.controlNumber.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Required"))
                                        : (_ctx.v$.controlObject.controlNumber.required && _ctx.v$.controlObject.controlNumber.restrictCharacters8.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Charcter Limit is exceeded"))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : (_ctx.checkControlNumber)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[40] || (_cache[40] = [
                                        _createElementVNode("div", { class: "error-text" }, "Control Number already exists", -1)
                                      ])))
                                    : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _cache[42] || (_cache[42] = _createElementVNode("label", { class: "controllabel" }, "Frequency", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.controlObject.controlFrequency,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.controlObject.controlFrequency) = $event)),
                                  options: _ctx.controlFrequency,
                                  optionLabel: "label",
                                  optionValue: "id",
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
												'is-invalid': _ctx.v$.controlObject.controlFrequency.$error,
												'inputboxstylingForSelectAtPopup': _ctx.controlObject.controlFrequency === '',
											}])
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.controlObject.controlFrequency.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      (_ctx.v$.controlObject.controlFrequency.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _cache[43] || (_cache[43] = _createElementVNode("label", { class: "controllabel" }, "Type", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
												'is-invalid': _ctx.v$.controlObject.controlType.$error
											}]),
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.controlObject.controlType) = $event)),
                                  placeholder: "Type",
                                  onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.v$.controlObject.controlType.$touch()))
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.controlObject.controlType,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.controlObject.controlType.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                      (_ctx.v$.controlObject.controlType.restrictCharacters30.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                _cache[44] || (_cache[44] = _createElementVNode("label", { class: "controllabel" }, "Priority", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.controlObject.controlPriority,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.controlObject.controlPriority) = $event)),
                                  options: _ctx.dbPriority,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
												'inputboxstylingForSelectAtPopup': _ctx.controlObject.controlPriority === '',
												'stylingForInputboxstylingForSelectAtPopup': _ctx.controlObject.controlPriority !== ''
											}])
                                }, null, 8, ["modelValue", "options", "class"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _cache[45] || (_cache[45] = _createElementVNode("label", { class: "controllabel" }, "Family", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
												'is-invalid': _ctx.v$.controlObject.controlFamily.$error
											}]),
                                  placeholder: "Family",
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.controlObject.controlFamily) = $event)),
                                  onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.v$.controlObject.controlFamily.$touch()))
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.controlObject.controlFamily,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.controlObject.controlFamily.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                      (_ctx.v$.controlObject.controlFamily.restrictCharacters30.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                _cache[46] || (_cache[46] = _createElementVNode("label", { class: "controllabel" }, "Class", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
												'is-invalid': _ctx.v$.controlObject.controlClass.$error
											}]),
                                  placeholder: "Class",
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.controlObject.controlClass) = $event)),
                                  onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.v$.controlObject.controlClass.$touch()))
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.controlObject.controlClass,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.controlObject.controlClass.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                      (_ctx.v$.controlObject.controlClass.restrictCharacters30.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _cache[47] || (_cache[47] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
												'is-invalid': _ctx.v$.controlObject.Description.$error
											}]),
                                  placeholder: "Description",
                                  onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.v$.controlObject.Description.$touch())),
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.controlObject.Description) = $event))
                                }, " \n\t\t\t\t\t\t\t\t\t\t", 34), [
                                  [
                                    _vModelText,
                                    _ctx.controlObject.Description,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.controlObject.Description.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                      (_ctx.v$.controlObject.Description.restrictCharacters1000.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _cache[48] || (_cache[48] = _createElementVNode("label", { class: "controllabel" }, "Tasks", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
												'is-invalid': _ctx.v$.controlObject.controlMaintenanceTask.$error
											}]),
                                  placeholder: "Maintenance Task",
                                  onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.v$.controlObject.controlMaintenanceTask.$touch())),
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.controlObject.controlMaintenanceTask) = $event))
                                }, " \n\t\t\t\t\t\t\t\t\t\t", 34), [
                                  [
                                    _vModelText,
                                    _ctx.controlObject.controlMaintenanceTask,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.controlObject.controlMaintenanceTask.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                      (_ctx.v$.controlObject.controlMaintenanceTask.restrictCharacters1000.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("div", _hoisted_51, [
                                _cache[49] || (_cache[49] = _createElementVNode("label", { class: "controllabel" }, "Policies", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
												'is-invalid': _ctx.v$.controlObject.controlPolicies.$error
											}]),
                                  placeholder: "Policies",
                                  onInput: _cache[23] || (_cache[23] = ($event: any) => (_ctx.v$.controlObject.controlPolicies.$touch())),
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.controlObject.controlPolicies) = $event))
                                }, " \n\t\t\t\t\t\t\t\t\t\t", 34), [
                                  [
                                    _vModelText,
                                    _ctx.controlObject.controlPolicies,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.controlObject.controlPolicies.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                      (_ctx.v$.controlObject.controlPolicies.restrictCharacters300.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _cache[50] || (_cache[50] = _createElementVNode("label", { class: "controllabel" }, "Guidance", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text-area",
                                  class: _normalizeClass(["inputboxstyling mt-2", {
												'is-invalid': _ctx.v$.controlObject.controlGuidance.$error
											}]),
                                  placeholder: "Guidance",
                                  onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.v$.controlObject.controlGuidance.$touch())),
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.controlObject.controlGuidance) = $event))
                                }, " \n\t\t\t\t\t\t\t\t\t\t", 34), [
                                  [
                                    _vModelText,
                                    _ctx.controlObject.controlGuidance,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.controlObject.controlGuidance.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                      (_ctx.v$.controlObject.controlGuidance.restrictCharacters1000.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_58, [
                              _cache[51] || (_cache[51] = _createElementVNode("label", { class: "controllabel" }, "Frameworks", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.controlObject.controlOptionFrameWork,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.controlObject.controlOptionFrameWork) = $event)),
                                options: _ctx.frameWorksList,
                                optionLabel: "label",
                                optionValue: "label",
                                onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.getFrameworkControls(_ctx.controlObject.controlOptionFrameWork))),
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
										'inputboxstylingForSelectAtPopup': _ctx.controlObject.controlOptionFrameWork === '',
										'stylingForInputboxstylingForSelectAtPopup': _ctx.controlObject.controlOptionFrameWork !== ''
									}])
                              }, null, 8, ["modelValue", "options", "class"])
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              _cache[52] || (_cache[52] = _createElementVNode("label", { class: "controllabel" }, "Controls", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.controlObject.frameworkControls,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.controlObject.frameworkControls) = $event)),
                                options: _ctx.frameworkControls,
                                optionLabel: "label",
                                optionValue: "value",
                                disabled: _ctx.controlObject.controlOptionFrameWork==='',
                                appendTo: "self",
                                placeholder: "Please select one",
                                class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
											'inputboxstylingForSelectAtPopup': _ctx.controlObject.controlOptionFrameWork === '',
											'stylingForInputboxstylingForSelectAtPopup': _ctx.controlObject.controlOptionFrameWork !== ''
										}])
                              }, null, 8, ["modelValue", "options", "disabled", "class"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[53] || (_cache[53] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                          onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onCancelbtn(_ctx.controlObject._id)))
                        }, "Reset", 2),
                        (!_ctx.controlObject._id)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: _normalizeClass(["btnprimary", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.saveCustomControl(_ctx.controlObject)))
                            }, "Save", 2))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: _normalizeClass(["btnprimary", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                              disabled: _ctx.clickonButton,
                              onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.updateControl(_ctx.controlObject)))
                            }, "Save", 10, _hoisted_61))
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["popUp"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}